var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5714C0 12.7919 12.7919 0 28.5714 0H71.4286C87.2081 0 100 12.7919 100 28.5714V71.4286C100 87.2081 87.2081 100 71.4286 100H28.5714C12.7919 100 0 87.2081 0 71.4286V28.5714Z",
    fill: "#406FE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3306 62.9374L68.3753 71.4016C68.6431 73.6248 66.2592 75.1783 64.3574 74.0265L53.1342 67.3569C51.9021 67.3569 50.6967 67.2766 49.5182 67.1159C51.5003 64.7856 52.6789 61.8391 52.6789 58.6516C52.6789 51.0444 46.0896 44.8838 37.9467 44.8838C34.8396 44.8838 31.9735 45.7677 29.5896 47.3213C29.5092 46.6516 29.4824 45.9819 29.4824 45.2855C29.4824 33.098 40.0628 23.2141 53.1342 23.2141C66.2056 23.2141 76.786 33.098 76.786 45.2855C76.786 52.5177 73.0628 58.9195 67.3306 62.9374Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6786 58.651C52.6786 61.8385 51.5001 64.7851 49.5179 67.1154C46.8662 70.3297 42.6608 72.3921 37.9465 72.3921L30.9554 76.5439C29.7769 77.2671 28.2768 76.2761 28.4376 74.91L29.1072 69.6333C25.5179 67.1422 23.2144 63.151 23.2144 58.651C23.2144 53.9367 25.7322 49.785 29.5894 47.3207C31.9733 45.7672 34.8394 44.8833 37.9465 44.8833C46.0894 44.8833 52.6786 51.0439 52.6786 58.651Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_902",
    x1: 43.93,
    y1: 5.09124e-7,
    x2: 43.93,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#689DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948917,
    stopColor: "#3967DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Chat.29632b65.svg";
export { ForwardRef as ReactComponent };